"use client";

import { assertNotNullish } from "./assertNotNullish";
import { Locale } from "./locales.types";
import { createContext, useContext } from "react";

type LocaleStringContextValue = {
  localeString: string;
  matchingLocale: Locale | undefined;
};

const LocaleStringContext = createContext<LocaleStringContextValue | undefined>(
  undefined,
);

export const LocaleStringContextProvider = (
  args: React.ComponentProps<typeof LocaleStringContext.Provider>,
) => <LocaleStringContext.Provider {...args} />;

export const useLocaleStringContext = (): string => {
  const context = useContext(LocaleStringContext);

  assertNotNullish(
    context,
    "useLocaleStringContext was used outside of Provider",
  );

  return context.localeString;
};

export const useMatchingLocaleContext = (): Locale | undefined => {
  const context = useContext(LocaleStringContext);

  assertNotNullish(
    context,
    "useMatchingLocaleContext was used outside of Provider",
  );

  return context.matchingLocale;
};
